module.exports = __webpack_public_path__ + "img/Antonia&Stephan-09.7fe4f7db.jpg";